// Model names - not translated as these are product names
export const MODEL_NAMES = {
  WAN: "Wan 2.5",
  LIPSYNC: "Veed LipSync",
  UPSCALE: "Topaz Video Upscale",
  NANO_BANANA: "Nano Banana 2",
  IMAGE_UPSCALE: "Topaz Image Upscale",
} as const;
export const MODELS = [MODEL_NAMES.WAN, MODEL_NAMES.LIPSYNC, MODEL_NAMES.UPSCALE];
export const IMAGE_MODELS = [MODEL_NAMES.NANO_BANANA, MODEL_NAMES.IMAGE_UPSCALE];

export const TIMING = {
  // Base durations (in seconds)
  DURATION: {
    INSTANT: 0.2, // Very quick (200ms)
    FAST: 0.3, // Fast (300ms)
    MEDIUM: 0.4, // Standard (400ms)
    SLOW: 0.6, // Slow (600ms)
    SLOWER: 0.8, // Very slow (800ms)
  },

  // Sequential delays - add these to create visible pauses between steps
  DELAY: {
    NONE: 0,
    SHORT: 0.3, // Short pause (300ms)
    MEDIUM: 0.5, // Medium pause (500ms)
    LONG: 0.7, // Long pause (700ms)
    EXTRA_LONG: 1.0, // Extra long pause (1000ms)
  },

  // Easing curves
  EASE: {
    STANDARD: [0.4, 0, 0.2, 1] as const, // Smooth deceleration
    LINEAR: "linear" as const, // Constant speed
  },
} as const;

// Common transition presets - use these for typical animations
export const TRANSITIONS = {
  // Quick opacity/scale changes
  instant: {
    duration: TIMING.DURATION.INSTANT,
    ease: TIMING.EASE.STANDARD,
  },

  // Standard UI transitions
  fast: {
    duration: TIMING.DURATION.FAST,
    ease: TIMING.EASE.STANDARD,
  },

  // Medium-paced animations
  medium: {
    duration: TIMING.DURATION.MEDIUM,
    ease: TIMING.EASE.STANDARD,
  },

  // Slower, more dramatic transitions
  slow: {
    duration: TIMING.DURATION.SLOW,
    ease: TIMING.EASE.STANDARD,
  },

  // Very slow for major changes
  slower: {
    duration: TIMING.DURATION.SLOWER,
    ease: TIMING.EASE.STANDARD,
  },

  // Spinner rotation
  spinner: {
    duration: 1,
    repeat: 2,
    ease: TIMING.EASE.LINEAR,
  },
} as const;

export interface GridItem {
  type: "generate" | "upscale" | "lipsync" | "imageGenerate" | "imageUpscale";
  media: string; // Video URL
  status: "generating" | "complete";
  label?: string; // Display label during generating state
  hasAudio?: boolean; // Whether the video has audio and should show mute button
  imageUrl?: string; // Static image URL (used for original in generate demo)
  isImageResult?: boolean; // Whether the result is a static image (no video playback)
}
